import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getInstrumentsPaginated } from '../services/api';

/** 管理员可看全部库存；负责人仅可访问其负责仪器的库存管理 */
export function useCanAccessInstrumentStock() {
  const { role } = useAuth();
  const isStockAdmin = role === '管理员' || role === '超级管理员';
  const [canAccessStock, setCanAccessStock] = useState(isStockAdmin);
  const [loading, setLoading] = useState(!isStockAdmin);

  useEffect(() => {
    if (isStockAdmin) {
      setCanAccessStock(true);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    (async () => {
      try {
        const r = await getInstrumentsPaginated({ page: 1, pageSize: 1, managedOnly: true });
        if (!cancelled) {
          setCanAccessStock(Boolean(r.success && r.data && r.data.total > 0));
        }
      } catch {
        if (!cancelled) setCanAccessStock(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isStockAdmin]);

  return { canAccessStock, isStockAdmin, loading };
}
